import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Divider, Popover, Typography } from 'antd';

import { getTranslatedString } from '@/utils';

interface FormDividerProps {
  name?: string;
  i18nLabel: string;
  /** Optional: show a help icon that opens long-form guidance (Popover, click). */
  i18nHelpTitle?: string;
  i18nHelpDescription?: string;
  /** Accessible name for the help control (describe the action, not only the topic). */
  i18nHelpAriaLabel?: string;
}

/** Section heading inside generic forms (compatible with Ant Design 4.x). */
export function FormDivider({ i18nLabel, i18nHelpTitle, i18nHelpDescription, i18nHelpAriaLabel }: FormDividerProps) {
  const labelText = getTranslatedString(i18nLabel);
  const hasHelp = Boolean(i18nHelpTitle && i18nHelpDescription);

  const helpControl = hasHelp ? (
    <Popover
      title={getTranslatedString(i18nHelpTitle!)}
      content={
        <div
          style={{
            maxWidth: 400,
            maxHeight: 280,
            overflowY: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {getTranslatedString(i18nHelpDescription!)}
        </div>
      }
      trigger="click"
      placement="bottomLeft"
      overlayStyle={{ maxWidth: 440 }}
    >
      <Button
        type="link"
        htmlType="button"
        size="small"
        icon={<QuestionCircleOutlined />}
        aria-label={i18nHelpAriaLabel ? getTranslatedString(i18nHelpAriaLabel) : getTranslatedString(i18nHelpTitle!)}
        style={{ padding: 0, height: 'auto', lineHeight: 1, verticalAlign: 'middle' }}
      />
    </Popover>
  ) : null;

  return (
    <div style={{ marginTop: 12, marginBottom: 4 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          columnGap: 6,
          rowGap: 4,
        }}
      >
        <Typography.Text strong>{labelText}</Typography.Text>
        {helpControl}
      </div>
      <Divider style={{ margin: '8px 0 16px' }} />
    </div>
  );
}
